import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaitomahabaleshwarcab() {



  const cardData = {
    keyword: " Navi Mumbai to Mahabaleshwar Cab ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai to Mahabaleshwar cab service, providing safe, comfortable, and affordable hill station travel for families, couples, groups, and weekend tourists. Mahabaleshwar is a beautiful hill station in the Western Ghats located approximately 220–260 km from Navi Mumbai, known for its cool climate, scenic viewpoints, strawberry farms, waterfalls, and lush green valleys. Our professional drivers ensure a smooth and stress-free journey via well-maintained highways with safe driving and timely pickup. We offer flexible options including one-way drops, round trips, weekend packages, and customized sightseeing tours. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is your trusted choice for Navi Mumbai to Mahabaleshwar cab service.",

"topPlaces": [
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat is one of the most famous viewpoints in Mahabaleshwar offering breathtaking panoramic views of deep valleys, river formations, and the surrounding Western Ghats. It is often called the ‘Queen of Points’ and is especially popular during sunrise and sunset, making it a must-visit spot for travelers coming from Navi Mumbai."
  },
  {
    "title": "Venna Lake",
    "description": "Venna Lake is a scenic man-made lake surrounded by lush greenery and horse-riding tracks. Visitors enjoy boating, horse rides, and street food stalls along the lakeside, making it a perfect family-friendly attraction in Mahabaleshwar."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a famous tourist attraction known for its strawberry products, fresh fruit-based desserts, and beautiful garden ambiance. It is a popular stop for food lovers and families traveling to Mahabaleshwar, offering chocolate shakes, strawberries, and picnic spaces."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a natural rock formation resembling an elephant’s head and trunk. It offers stunning cliff views, misty surroundings, and is a favorite photography and sightseeing spot, especially during monsoon season."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a beautiful seasonal waterfall surrounded by dense forest and valleys. It is one of the most visited natural attractions in Mahabaleshwar, especially during monsoon when the waterfall is in full flow and the surroundings become lush green."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point is the highest point in Mahabaleshwar and is famous for its breathtaking sunrise views. Visitors gather early morning to witness the sun rising above the clouds, creating a magical experience for tourists."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort is a historic fort built by Chhatrapati Shivaji Maharaj, located near Mahabaleshwar. It is known for its strategic importance, strong architecture, and panoramic views of the surrounding valleys and hills."
  },
  {
    "title": "Panchgani Plateau (Nearby)",
    "description": "Panchgani Plateau is a nearby hill station region known for Table Land, scenic viewpoints, and colonial-era charm. It is often combined with Mahabaleshwar sightseeing tours for a complete hill station experience."
  },
  {
    "title": "Strawberry Farms",
    "description": "Mahabaleshwar is famous for its strawberry farms where visitors can see fresh strawberry cultivation, enjoy farm tours, and taste freshly picked fruits. It is especially popular during the strawberry season from winter to early summer."
  },
  {
    "title": "Tapola (Mini Kashmir)",
    "description": "Tapola, also known as Mini Kashmir, is a peaceful lakeside destination near Mahabaleshwar offering boating, nature views, and serene landscapes. It is ideal for relaxation and adventure activities like kayaking and trekking."
  }
],






services: [
  {
    name: "Mumbai to Mahabaleshwar Cab",
    description: "Mumbai to Mahabaleshwar cab service offers a scenic and comfortable journey to one of Maharashtra’s most popular hill stations. Ideal for weekend getaways, family trips, and couples, this service ensures smooth travel via highways and ghat roads. Professional drivers enhance safety. It guarantees a relaxing travel experience."
  },
  {
    name: "Mumbai to Mahabaleshwar Taxi Fare",
    description: "Mumbai to Mahabaleshwar taxi fare is transparent and budget-friendly based on vehicle type and trip duration. Customers receive clear pricing before booking. No hidden charges ensure trust. It helps in planning travel costs efficiently."
  },
  {
    name: "Mumbai to Mahabaleshwar Taxi",
    description: "Mumbai to Mahabaleshwar taxi provides private and comfortable travel for long-distance hill station trips. This service includes door-to-door pickup and flexible schedules. Comfortable seating enhances the journey. It guarantees a smooth ride."
  },
  {
    name: "Car from Mumbai to Mahabaleshwar",
    description: "Car from Mumbai to Mahabaleshwar offers a convenient and enjoyable road trip experience. Ideal for families and tourists, this service ensures safe travel with experienced drivers. It guarantees a comfortable journey."
  },
  {
    name: "Mumbai to Mahabaleshwar Cab Booking",
    description: "Mumbai to Mahabaleshwar cab booking allows easy reservation with flexible travel options. Customers can select vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Mahabaleshwar Round Trip Cab",
    description: "Mumbai to Mahabaleshwar round trip cab provides complete travel solutions including return journeys. Ideal for weekend vacations and sightseeing. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Taxi for Mahabaleshwar from Mumbai",
    description: "Taxi for Mahabaleshwar from Mumbai offers comfortable and reliable travel for tourists and families. This service ensures smooth road journeys with professional drivers. It guarantees a pleasant travel experience."
  },
  {
    name: "Navi Mumbai to Mahabaleshwar Cab",
    description: "Navi Mumbai to Mahabaleshwar cab service provides direct and convenient travel to the hill station. Ideal for weekend trips and leisure travel. Clean vehicles and experienced drivers ensure safety. It guarantees a relaxing journey."
  },
  {
    name: "Navi Mumbai to Mahabaleshwar Taxi",
    description: "Navi Mumbai to Mahabaleshwar taxi offers private and flexible travel options for individuals and groups. Comfortable seating enhances the experience. Suitable for long-distance travel. It guarantees reliability."
  },
  {
    name: "Navi Mumbai to Mahabaleshwar Cab Service",
    description: "Navi Mumbai to Mahabaleshwar cab service ensures dependable transportation with well-maintained vehicles and trained drivers. Ideal for family trips and corporate outings. It ensures a safe and smooth journey."
  },
  {
    name: "Taxi from Navi Mumbai to Mahabaleshwar",
    description: "Taxi from Navi Mumbai to Mahabaleshwar provides reliable long-distance travel with professional drivers. This service ensures smooth journeys through scenic routes. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Cab from Navi Mumbai to Mahabaleshwar",
    description: "Cab from Navi Mumbai to Mahabaleshwar offers convenient and comfortable travel for hill station trips. Ideal for tourists and families. Professional drivers ensure safe journeys. It ensures a relaxed experience."
  },
  {
    name: "Book Cab Navi Mumbai to Mahabaleshwar",
    description: "Book cab Navi Mumbai to Mahabaleshwar with easy online booking and instant confirmation. Customers can select vehicle type and timing based on convenience. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Online Cab Booking Navi Mumbai to Mahabaleshwar",
    description: "Online cab booking Navi Mumbai to Mahabaleshwar provides a fast and convenient way to reserve your ride. Secure payment and instant confirmation enhance convenience. Multiple vehicle options are available. It ensures hassle-free booking."
  },
  {
    name: "Best Cab Navi Mumbai to Mahabaleshwar",
    description: "Best cab Navi Mumbai to Mahabaleshwar ensures top-quality vehicles, professional drivers, and excellent service. This service focuses on comfort, safety, and punctuality. It guarantees a premium travel experience."
  },
  {
    name: "Cheapest Cab Navi Mumbai to Mahabaleshwar",
    description: "Cheapest cab Navi Mumbai to Mahabaleshwar offers budget-friendly travel options without compromising comfort. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical travel."
  }
],

tableData: [
  ["Mumbai to Mahabaleshwar Cab", "Mumbai to Mahabaleshwar Taxi Fare"],
  ["Mumbai to Mahabaleshwar Taxi", "Car from Mumbai to Mahabaleshwar"],
  ["Mumbai to Mahabaleshwar Cab Booking", "Mumbai to Mahabaleshwar Round Trip Cab"],
  ["Taxi for Mahabaleshwar from Mumbai", "Navi Mumbai to Mahabaleshwar Cab"],
  ["Navi Mumbai to Mahabaleshwar Taxi", "Navi Mumbai to Mahabaleshwar Cab Service"],
  ["Taxi from Navi Mumbai to Mahabaleshwar", "Cab from Navi Mumbai to Mahabaleshwar"],
  ["Book Cab Navi Mumbai to Mahabaleshwar", "Online Cab Booking Navi Mumbai to Mahabaleshwar"],
  ["Best Cab Navi Mumbai to Mahabaleshwar", "Cheapest Cab Navi Mumbai to Mahabaleshwar"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai to Mahabaleshwar Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Navi Mumbai to Mahabaleshwar cab service, ideal for hill station trips, family vacations, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Ghat Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained in handling ghat and hill routes, ensuring safe driving and smooth navigation to Mahabaleshwar."
  },
  {
    WhyChooseheading: "Perfect for Hill Station & Nature Trips",
    WhyChoosedescription: "Mahabaleshwar is a popular hill station known for scenic views and cool climate, making it perfect for couples, families, and group travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel plans for Mahabaleshwar trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Navi Mumbai to Mahabaleshwar cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Hill Station Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Navi Mumbai to Mahabaleshwar cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Navi Mumbai to Mahabaleshwar cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Navi Mumbai to Mahabaleshwar for one-way and round trips." },
  { question: "What is the distance between Navi Mumbai and Mahabaleshwar?", answer: "The distance is approximately 240 to 270 km and takes around 5 to 7 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Navi Mumbai to Mahabaleshwar cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for weekend trips?", answer: "Yes, Mahabaleshwar is ideal for weekend getaways and family trips." },
  { question: "Do you provide ghat route experienced drivers?", answer: "Yes, our drivers are experienced in hill and ghat driving." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for weekends and peak travel seasons." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Navi Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Patil",
    feedback: "The Navi Mumbai to Mahabaleshwar journey with Royal Route Cabs was very smooth and comfortable. The driver was experienced and ensured a safe hill drive throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "Royal Route Cabs made our Mahabaleshwar trip hassle-free. The car was clean, and the long drive through the hills was relaxing and well-managed.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Mahabaleshwar Cab",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-to-mahabaleshwar-cab.jpg", // replace if needed
  "description": "Book Navi Mumbai to Mahabaleshwar cab service with Royal Route Cabs for safe, scenic, and comfortable hill station travel. Available 24x7 with sedan, SUV, Innova, Ertiga, and premium vehicles for one-way and round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499", // approx starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-to-mahabaleshwar-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Navi Mumbai to Mahabaleshwar Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Mahabaleshwar cab with Royal Route Cabs. Enjoy safe and comfortable hill station travel with 24x7 taxi service, professional drivers, and affordable fares."
  />

  <meta
    name="keywords"
    content="mumbai to mahabaleshwar cab, mumbai to mahabaleshwar taxi fare, mumbai to mahabaleshwar taxi, car from mumbai to mahabaleshwar, mumbai to mahabaleshwar cab booking, mumbai to mahabaleshwar round trip cab, taxi for mahabaleshwar from mumbai, navi mumbai to mahabaleshwar cab, navi mumbai to mahabaleshwar taxi, navi mumbai to mahabaleshwar cab service, taxi from navi mumbai to mahabaleshwar, cab from navi mumbai to mahabaleshwar, book cab navi mumbai to mahabaleshwar, online cab booking navi mumbai to mahabaleshwar, best cab navi mumbai to mahabaleshwar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitomahabaleshwarcab;